import httpService from "./httpService";
// get error message from response
export const generateError = (error) => {
    if (error.message) {
        try {
            const message = JSON.parse(error.message);
            return JSON.parse(message.detail).error;
        }
        catch (e) {
            return error.message;
        }
    }
};
export function apiGetRechargeSubscriptions() {
    const endpoint = "/api/recharge/subscriptions/";
    return httpService.get(endpoint);
}
export function apiGetRechargeUpcomingOrder() {
    const endpoint = "/api/recharge/upcoming-order/";
    return httpService.get(endpoint);
}
export function apiGetProccessedOrders(limit, page) {
    const endpoint = `/api/recharge/orders/?limit=${limit}&page=${page}`;
    return httpService.get(endpoint);
}
export const apiUpdateOrderDate = (data, address_id) => {
    const endpoint = `/api/recharge/update-order-date/`;
    return httpService.post(endpoint, { data, address_id });
};
export const apiCancelRechargeSubscription = (data, address_id) => {
    const endpoint = `/api/recharge/cancel-subscription/`;
    return httpService.post(endpoint, { data, address_id });
};
export const apiGetRechargeAddress = () => {
    const endpoint = "/api/recharge/address/";
    return httpService.get(endpoint);
};
export const apiGetRechargeSubscriberData = () => {
    const endpoint = "/api/recharge/subscriber-data/";
    return httpService.get(endpoint);
};
export const apiUpdateAddress = ({ data, address_id, }) => {
    const endpoint = "/api/recharge/update-shipping-address/";
    return httpService.post(endpoint, { data, address_id });
};
export const apiUpdateSubscriberData = (data) => {
    const endpoint = "/api/recharge/update-subscriber-data/";
    return httpService.post(endpoint, data);
};
export const apiAddSubscription = (data) => {
    const endpoint = "/api/recharge/add-subscription/";
    return httpService.post(endpoint, data);
};
export const apiUpdateSubscription = (data) => {
    const endpoint = "/api/recharge/update-subscription/";
    return httpService.post(endpoint, data);
};
export const apiRechargeDeleteSubscription = (subscriptionId) => {
    const endpoint = `/api/recharge/delete-subscription/`;
    return httpService.post(endpoint, { subscription_id: subscriptionId });
};
export const apiApplyDiscount = (data) => {
    const endpoint = "/api/recharge/apply-discount/";
    return httpService.post(endpoint, data);
};
export const apiDeleteDiscount = () => {
    const endpoint = "/api/recharge/remove-discount/";
    return httpService.post(endpoint);
};
